import { Button } from "@mui/material";

import { className } from "utils/strings";

import { ReactComponent as ActiveIcon } from "components/icons/FooterIcons/profileIconActive.svg";
import { ReactComponent as InActiveIcon } from "components/icons/FooterIcons/profileIconInactive.svg";

import "./buttons.scss";
import { showAuthModal } from "store/application/application-action";
import { useDispatch } from "react-redux";

export const ProfileButton = (props: {
  active: boolean;
  username: string|null;
  onClick: () => void;
}): JSX.Element => {
  const dispatch = useDispatch();

  const Icon = props.active
    ? ActiveIcon
    : InActiveIcon;

  const label = props.username ?? "Log in";

  const onClick = () => {
    if (props.username) {
      props.onClick();
    } else {
      dispatch(showAuthModal());
    }
  };

  return (
    <Button onClick={onClick} className={className({
      "profile": true,
      "active": props.active,
      "inactive": !props.active,
    })}>
      <Icon />
      <label>{label}</label>
    </Button>
  );
};
